import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  SpaciousSemantic_getInstance49m8xgr9xadn as SpaciousSemantic_getInstance,
  BannerSemantic_getInstance18p0b4btg61q8 as BannerSemantic_getInstance,
} from '../../theme/semantics.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H2Semantic1i9pxrezr3hyb as get_H2Semantic,
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
  SubtextSemantic_getInstance1duu1ll1kgx8d as SubtextSemantic_getInstance,
  None_instance1vdtnxdfytk8h as None_instance,
  SelectedSemantic_getInstance3adr60xrkcq3z as SelectedSemantic_getInstance,
  DangerSemantic_getInstance1xd9zwrvs99lp as DangerSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  CareLocation1v3u5wduz023s as CareLocation,
  get_entries3htl3g20ei9sb as get_entries,
  LocationAttendancePeriod3bx3r7kkwecs9 as LocationAttendancePeriod,
  ID1z61wlmtvxrjn as ID,
  ChildPlacement1fdgqwhgo48yv as ChildPlacement,
  ClosureReason_Holiday_getInstance1gv01vuec049b as ClosureReason_Holiday_getInstance,
  get_entriesor5jvw043r71 as get_entries_0,
  CareLocationClosure1da03s5ze3kft as CareLocationClosure,
  ID2snwv1w0j940u as ID_0,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_name29bc1mdqu6171 as get_name,
  get_typeq73z1u2l6557 as get_type,
  get_address1er1ty3qehev7 as get_address,
  get_line12qowz8aajkggm as get_line1,
  get_line22yru7ztqlgmow as get_line2,
  get_city182djzl8rp5cw as get_city,
  get_state1oesqq81882tl as get_state,
  get_postalCodeb3j2izx1u631 as get_postalCode,
  get_contact196vi87vu7eim as get_contact,
  get_name1iemflb9d8z7b as get_name_0,
  get_emailbv7cfcsvgkdr as get_email,
  get_phone31swsuqbmo9e as get_phone,
  get_locationrgfu4uek4c14 as get_location,
  get_location1p3um6ao7ento as get_location_0,
  get_signedDocument3640hkwsv7915 as get_signedDocument,
  get_date13hdmf8teioql as get_date,
  get_reasondtlrxf4x79mr as get_reason,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { lensPath21i5dxhjzuxep as lensPath } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/serialization/MutableReactive.lens.DataClassPath.mjs';
import {
  assertNotBlank3rcqh0n27fq5q as assertNotBlank,
  assertNotNull1uaw2iegqzgw8 as assertNotNull,
} from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/helpers.mjs';
import {
  toList3jhuyej2anx2q as toList,
  first58ocm7j58k3q as first,
  plus310ted5e4i90h as plus,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
  Signal1973xs1vkmdcb as Signal,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  LabeledViewseav57tyecmf as LabeledView,
  LabelGapSemantic_getInstance2wftjv243mafi as LabelGapSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import {
  LabeledView$_get_content_$ref_5yojet1mvh3jfqyuzca as LabeledView$_get_content_$ref_5yojet,
  LabeledView$_set_content_$ref_ys1c8fi8j7ehqqddvg as LabeledView$_set_content_$ref_ys1c8f,
} from '../LoginScreen.mjs';
import {
  themed2vu67ornd4jps as themed,
  dynamicThemed3lsusnjffkq9e as dynamicThemed,
  get_bold3d63kt1t4c9r5 as get_bold,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { validatedmmpm5lnzq3lm as validated } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/entrypoints.mjs';
import {
  withStringBufferw9sv07w4j3wo as withStringBuffer,
  withStringBuffer3khj76irczpue as withStringBuffer_0,
} from '../components/validation.mjs';
import { PhoneNumberInput1tdzv8kpf7vme as PhoneNumberInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/PhoneNumberInput.mjs';
import { get_standardDialogWidth1plathvfuoe55 as get_standardDialogWidth } from '../components/view-utilities.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
  get_scrolling3fwkltztkpfe8 as get_scrolling,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import {
  dialog3sxbjr735jrum as dialog,
  toast4hp3bb4ymp24 as toast,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import {
  LocalDate31mqn6zavbpi8 as LocalDate,
  plus1oi9f9vif99u2 as plus_0,
  minushnjyym3nfk5o as minus,
} from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import { DatePeriod2y4m7pf19ebgd as DatePeriod } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/DateTimePeriod.mjs';
import {
  ClosedLocalDateRange6599xgap66zd as ClosedLocalDateRange,
  LocalDateRangefowoyqa24icz as LocalDateRange,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/types.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  eq353yrgcpovoi1 as eq,
  neqpgb3jcwulnab as neq,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  and3dbt2f202um49 as and,
  Always_getInstance177eud73uc475 as Always_getInstance,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import {
  nowLocal2mdv5rmil2cf2 as nowLocal,
  today1rno4frfjp5oe as today,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/clock.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import {
  get_stringsy7vodl9dj0ya as get_strings,
  StringsForLanguage_English_getInstance2jm5ip12elsyk as StringsForLanguage_English_getInstance,
} from '../../strings.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { colOfv2oygjkn5hb2 as colOf } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/lists.mjs';
import {
  Button$_get_enabled_$ref_61t7nx58ibx9ifxb3n as Button$_get_enabled_$ref_61t7nx,
  Button$_set_enabled_$ref_o8kynzfmpduwei6tot as Button$_set_enabled_$ref_o8kynz,
} from '../applications/FamilyApplicationDetailPage.mjs';
import {
  subtext2yjmf1ok7kb40 as subtext,
  text189ciz0cnr32o as text,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { audit192z89pit0lev as audit } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/validation.mjs';
import {
  TextInput$_get_hint_$ref_uvwrja1fc638uz6ch32 as TextInput$_get_hint_$ref_uvwrja,
  TextInput$_set_hint_$ref_i30g2i16lyp5h9o9qbl as TextInput$_set_hint_$ref_i30g2i,
} from '../children/NewChildPlacementPage.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  orPromise1iucc2to2udt2 as orPromise,
  $3l5vvh8yg0ier as $,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import {
  await1uwe8zvsjq69o as await_0,
  await1xlt6i5aa076q as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_pageNavigatorp3to6r4j8ctv as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { AttendancePeriodDetailPage2fnxdkx3t2m6k as AttendancePeriodDetailPage } from '../attendance/AttendancePeriodDetailPage.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { confirmationDialoginprr3lfvaqc as confirmationDialog } from '../components/dialogs.mjs';
import { ModificationBuilder10ot0rvxki4iq as ModificationBuilder } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ModificationBuilder.mjs';
import { ReactiveState__getOrNull_impl_1asnfp338k3yl4xmyxq as ReactiveState__getOrNull_impl_1asnfp } from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { CareLocationProgrameuu05ugy00sb as CareLocationProgram } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/careRates.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function locationForm(form, _this__u8e3s4, location, withCards) {
  // Inline function 'kotlin.with' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(true);
  if (!withCards) {
    element.set_themeChoice_py59um_k$(element.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SpaciousSemantic_getInstance()));
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  element.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(true);
  if (withCards) {
    element_0.set_themeChoice_py59um_k$(element_0.get_themeChoice_22tyn3_k$().plus_duvq05_k$(CardSemantic_getInstance()));
  }
  var tmp = locationForm$lambda;
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
  var tmp$ret$12 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$12);
  var tmp$ret$13 = get_name(it);
  var tmp$ret$10 = lensPath(location, tmp$ret$13);
  form.stringField$default_pwglgw_k$(element_0, tmp, assertNotBlank(tmp$ret$10), true);
  var tmp_1 = locationForm$lambda_0;
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_2 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
  var tmp$ret$16 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$16);
  var tmp$ret$17 = get_type(it_0);
  var tmp_3 = lensPath(location, tmp$ret$17);
  var tmp_4 = _Constant___init__impl__v45mub(toList(get_entries()));
  form.selectField_qav2qe_k$(element_0, tmp_1, tmp_3, new (Constant())(tmp_4), true, locationForm$lambda_1);
  element_0.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (RowOrCol())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  element.willAddChild_hz2iwc_k$(element_1);
  element_1.set_vertical_nuap32_k$(true);
  if (withCards) {
    element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(CardSemantic_getInstance()));
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (TextView())(element_1.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  element_1.willAddChild_hz2iwc_k$(element_2);
  element_2.set_themeChoice_py59um_k$(element_2.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
  var tmp_5 = KMutableProperty0();
  var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_2);
  var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_2));
  element_2.invoke_bnq13k_k$(tmp_7, locationForm$lambda_2);
  element_2.onStartup_vrxh3i_k$();
  element_1.addChild_2qpft2_k$(element_2);
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element_1.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  element_1.willAddChild_hz2iwc_k$(element_3);
  var tmp_8 = KMutableProperty0();
  var tmp_9 = LabeledView$_get_content_$ref_5yojet(element_3);
  var tmp_10 = getPropertyCallableRef('content', 0, tmp_8, tmp_9, LabeledView$_set_content_$ref_ys1c8f(element_3));
  element_3.invoke_bnq13k_k$(tmp_10, locationForm$lambda_3);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  var this_0 = themed(element_3, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_4 = new (TextInput())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_4);
  this_0.willAddChild_hz2iwc_k$(element_4);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_11 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
  var tmp$ret$36 = isInterface(tmp_11, KSerializer()) ? tmp_11 : THROW_CCE();
  var it_1 = new (DataClassPathSelf())(tmp$ret$36);
  var tmp$ret$37 = get_line1(get_address(it_1));
  var tmp$ret$34 = lensPath(location, tmp$ret$37);
  element_4.bind_gesskf_k$(element_4.content_1, tmp$ret$34);
  element_4.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_4);
  element_3.onStartup_vrxh3i_k$();
  element_1.addChild_2qpft2_k$(element_3);
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_5 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element_1.get_context_h02k06_k$());
  ensureOutermostElement(element_5);
  element_1.willAddChild_hz2iwc_k$(element_5);
  var tmp_12 = KMutableProperty0();
  var tmp_13 = LabeledView$_get_content_$ref_5yojet(element_5);
  var tmp_14 = getPropertyCallableRef('content', 0, tmp_12, tmp_13, LabeledView$_set_content_$ref_ys1c8f(element_5));
  element_5.invoke_bnq13k_k$(tmp_14, locationForm$lambda_4);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  var this_1 = themed(element_5, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_6 = new (TextInput())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_6);
  this_1.willAddChild_hz2iwc_k$(element_6);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_15 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
  var tmp$ret$47 = isInterface(tmp_15, KSerializer()) ? tmp_15 : THROW_CCE();
  var it_2 = new (DataClassPathSelf())(tmp$ret$47);
  var tmp$ret$48 = get_line2(get_address(it_2));
  var tmp$ret$45 = lensPath(location, tmp$ret$48);
  element_6.bind_gesskf_k$(element_6.content_1, tmp$ret$45);
  element_6.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_6);
  element_5.onStartup_vrxh3i_k$();
  element_1.addChild_2qpft2_k$(element_5);
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_7 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element_1.get_context_h02k06_k$());
  ensureOutermostElement(element_7);
  element_1.willAddChild_hz2iwc_k$(element_7);
  var tmp_16 = KMutableProperty0();
  var tmp_17 = LabeledView$_get_content_$ref_5yojet(element_7);
  var tmp_18 = getPropertyCallableRef('content', 0, tmp_16, tmp_17, LabeledView$_set_content_$ref_ys1c8f(element_7));
  element_7.invoke_bnq13k_k$(tmp_18, locationForm$lambda_5);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  var this_2 = themed(element_7, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_8 = new (TextInput())(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_8);
  this_2.willAddChild_hz2iwc_k$(element_8);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_19 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
  var tmp$ret$58 = isInterface(tmp_19, KSerializer()) ? tmp_19 : THROW_CCE();
  var it_3 = new (DataClassPathSelf())(tmp$ret$58);
  var tmp$ret$59 = get_city(get_address(it_3));
  var tmp$ret$56 = lensPath(location, tmp$ret$59);
  element_8.bind_gesskf_k$(element_8.content_1, tmp$ret$56);
  element_8.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_8);
  element_7.onStartup_vrxh3i_k$();
  element_1.addChild_2qpft2_k$(element_7);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_9 = new (RowOrCol())(element_1.get_context_h02k06_k$());
  ensureOutermostElement(element_9);
  element_1.willAddChild_hz2iwc_k$(element_9);
  element_9.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  var this_3 = weight(element_9, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_10 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_10);
  this_3.willAddChild_hz2iwc_k$(element_10);
  var tmp_20 = KMutableProperty0();
  var tmp_21 = LabeledView$_get_content_$ref_5yojet(element_10);
  var tmp_22 = getPropertyCallableRef('content', 0, tmp_20, tmp_21, LabeledView$_set_content_$ref_ys1c8f(element_10));
  element_10.invoke_bnq13k_k$(tmp_22, locationForm$lambda_6);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  var this_4 = themed(element_10, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_11 = new (TextInput())(this_4.get_context_h02k06_k$());
  ensureOutermostElement(element_11);
  this_4.willAddChild_hz2iwc_k$(element_11);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_23 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
  var tmp$ret$74 = isInterface(tmp_23, KSerializer()) ? tmp_23 : THROW_CCE();
  var it_4 = new (DataClassPathSelf())(tmp$ret$74);
  var tmp$ret$75 = get_state(get_address(it_4));
  var tmp$ret$72 = lensPath(location, tmp$ret$75);
  element_11.bind_gesskf_k$(element_11.content_1, tmp$ret$72);
  element_11.onStartup_vrxh3i_k$();
  this_4.addChild_2qpft2_k$(element_11);
  element_10.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_10);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  var this_5 = weight(element_9, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_12 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(this_5.get_context_h02k06_k$());
  ensureOutermostElement(element_12);
  this_5.willAddChild_hz2iwc_k$(element_12);
  var tmp_24 = KMutableProperty0();
  var tmp_25 = LabeledView$_get_content_$ref_5yojet(element_12);
  var tmp_26 = getPropertyCallableRef('content', 0, tmp_24, tmp_25, LabeledView$_set_content_$ref_ys1c8f(element_12));
  element_12.invoke_bnq13k_k$(tmp_26, locationForm$lambda_7);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  var this_6 = themed(element_12, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_13 = new (TextInput())(this_6.get_context_h02k06_k$());
  ensureOutermostElement(element_13);
  this_6.willAddChild_hz2iwc_k$(element_13);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_27 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
  var tmp$ret$86 = isInterface(tmp_27, KSerializer()) ? tmp_27 : THROW_CCE();
  var it_5 = new (DataClassPathSelf())(tmp$ret$86);
  var tmp$ret$87 = get_postalCode(get_address(it_5));
  var tmp$ret$84 = lensPath(location, tmp$ret$87);
  element_13.bind_gesskf_k$(element_13.content_1, tmp$ret$84);
  element_13.onStartup_vrxh3i_k$();
  this_6.addChild_2qpft2_k$(element_13);
  element_12.onStartup_vrxh3i_k$();
  this_5.addChild_2qpft2_k$(element_12);
  element_9.onStartup_vrxh3i_k$();
  element_1.addChild_2qpft2_k$(element_9);
  element_1.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_14 = new (RowOrCol())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_14);
  element.willAddChild_hz2iwc_k$(element_14);
  element_14.set_vertical_nuap32_k$(true);
  if (withCards) {
    element_14.set_themeChoice_py59um_k$(element_14.get_themeChoice_22tyn3_k$().plus_duvq05_k$(CardSemantic_getInstance()));
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_15 = new (TextView())(element_14.get_context_h02k06_k$());
  ensureOutermostElement(element_15);
  element_14.willAddChild_hz2iwc_k$(element_15);
  element_15.set_themeChoice_py59um_k$(element_15.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
  var tmp_28 = KMutableProperty0();
  var tmp_29 = TextView$_get_content_$ref_4pzcwl(element_15);
  var tmp_30 = getPropertyCallableRef('content', 0, tmp_28, tmp_29, TextView$_set_content_$ref_pketfb(element_15));
  element_15.invoke_bnq13k_k$(tmp_30, locationForm$lambda_8);
  element_15.onStartup_vrxh3i_k$();
  element_14.addChild_2qpft2_k$(element_15);
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_16 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element_14.get_context_h02k06_k$());
  ensureOutermostElement(element_16);
  element_14.willAddChild_hz2iwc_k$(element_16);
  var tmp_31 = KMutableProperty0();
  var tmp_32 = LabeledView$_get_content_$ref_5yojet(element_16);
  var tmp_33 = getPropertyCallableRef('content', 0, tmp_31, tmp_32, LabeledView$_set_content_$ref_ys1c8f(element_16));
  element_16.invoke_bnq13k_k$(tmp_33, locationForm$lambda_9);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  var this_7 = themed(element_16, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_17 = new (TextInput())(this_7.get_context_h02k06_k$());
  ensureOutermostElement(element_17);
  this_7.willAddChild_hz2iwc_k$(element_17);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_34 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
  var tmp$ret$106 = isInterface(tmp_34, KSerializer()) ? tmp_34 : THROW_CCE();
  var it_6 = new (DataClassPathSelf())(tmp$ret$106);
  var tmp$ret$107 = get_name_0(get_contact(it_6));
  var tmp$ret$104 = lensPath(location, tmp$ret$107);
  element_17.bind_gesskf_k$(element_17.content_1, tmp$ret$104);
  element_17.onStartup_vrxh3i_k$();
  this_7.addChild_2qpft2_k$(element_17);
  element_16.onStartup_vrxh3i_k$();
  element_14.addChild_2qpft2_k$(element_16);
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_18 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element_14.get_context_h02k06_k$());
  ensureOutermostElement(element_18);
  element_14.willAddChild_hz2iwc_k$(element_18);
  var tmp_35 = KMutableProperty0();
  var tmp_36 = LabeledView$_get_content_$ref_5yojet(element_18);
  var tmp_37 = getPropertyCallableRef('content', 0, tmp_35, tmp_36, LabeledView$_set_content_$ref_ys1c8f(element_18));
  element_18.invoke_bnq13k_k$(tmp_37, locationForm$lambda_10);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  var this_8 = themed(element_18, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_19 = new (TextInput())(this_8.get_context_h02k06_k$());
  ensureOutermostElement(element_19);
  this_8.willAddChild_hz2iwc_k$(element_19);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_38 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
  var tmp$ret$117 = isInterface(tmp_38, KSerializer()) ? tmp_38 : THROW_CCE();
  var it_7 = new (DataClassPathSelf())(tmp$ret$117);
  var tmp$ret$118 = get_email(get_contact(it_7));
  var tmp$ret$115 = lensPath(location, tmp$ret$118);
  element_19.bind_gesskf_k$(element_19.content_1, withStringBuffer(validated(tmp$ret$115)));
  element_19.onStartup_vrxh3i_k$();
  this_8.addChild_2qpft2_k$(element_19);
  element_18.onStartup_vrxh3i_k$();
  element_14.addChild_2qpft2_k$(element_18);
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_20 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element_14.get_context_h02k06_k$());
  ensureOutermostElement(element_20);
  element_14.willAddChild_hz2iwc_k$(element_20);
  var tmp_39 = KMutableProperty0();
  var tmp_40 = LabeledView$_get_content_$ref_5yojet(element_20);
  var tmp_41 = getPropertyCallableRef('content', 0, tmp_39, tmp_40, LabeledView$_set_content_$ref_ys1c8f(element_20));
  element_20.invoke_bnq13k_k$(tmp_41, locationForm$lambda_11);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.phoneNumberInput' call
  var this_9 = themed(element_20, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_21 = PhoneNumberInput().new_com_lightningkite_kiteui_views_direct_PhoneNumberInput_w1yrw4_k$(this_9.get_context_h02k06_k$());
  ensureOutermostElement(element_21);
  this_9.willAddChild_hz2iwc_k$(element_21);
  var tmp_42 = element_21.get_content_h02jrk_k$();
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_43 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
  var tmp$ret$128 = isInterface(tmp_43, KSerializer()) ? tmp_43 : THROW_CCE();
  var it_8 = new (DataClassPathSelf())(tmp$ret$128);
  var tmp$ret$129 = get_phone(get_contact(it_8));
  var tmp$ret$126 = lensPath(location, tmp$ret$129);
  element_21.bind_gesskf_k$(tmp_42, withStringBuffer_0(validated(tmp$ret$126)));
  element_21.onStartup_vrxh3i_k$();
  this_9.addChild_2qpft2_k$(element_21);
  element_20.onStartup_vrxh3i_k$();
  element_14.addChild_2qpft2_k$(element_20);
  element_14.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_14);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return element;
}
function addLocationDialog(form, _this__u8e3s4, location, clearDraft) {
  // Inline function 'kotlin.with' call
  var $this$with = form;
  dialog(_this__u8e3s4, VOID, ($this$dialog, close) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    var this_0 = get_scrolling(sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, get_standardDialogWidth()));
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
    ensureOutermostElement(element);
    this_0.willAddChild_hz2iwc_k$(element);
    element.set_vertical_nuap32_k$(true);
    // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = new (TextView())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    element.willAddChild_hz2iwc_k$(element_0);
    element_0.set_themeChoice_py59um_k$(element_0.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
    var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
    element_0.invoke_bnq13k_k$(tmp_1, addLocationDialog$lambda$lambda);
    element_0.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_0);
    locationForm($this$with, element, location, false);
    // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_1 = new (Separator())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_1);
    element.willAddChild_hz2iwc_k$(element_1);
    element_1.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_2 = new (RowOrCol())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_2);
    element.willAddChild_hz2iwc_k$(element_2);
    element_2.set_vertical_nuap32_k$(false);
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    var this_1 = themed(element_2, ButtonSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_3 = new (Button())(this_1.get_context_h02k06_k$());
    ensureOutermostElement(element_3);
    this_1.willAddChild_hz2iwc_k$(element_3);
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_4 = new (TextView())(element_3.get_context_h02k06_k$());
    ensureOutermostElement(element_4);
    element_3.willAddChild_hz2iwc_k$(element_4);
    var tmp_2 = KMutableProperty0();
    var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_4);
    var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_4));
    element_4.invoke_bnq13k_k$(tmp_4, addLocationDialog$lambda$lambda_0);
    element_4.onStartup_vrxh3i_k$();
    element_3.addChild_2qpft2_k$(element_4);
    onClick(element_3, VOID, VOID, VOID, addLocationDialog$lambda$slambda(location, close));
    element_3.onStartup_vrxh3i_k$();
    this_1.addChild_2qpft2_k$(element_3);
    // Inline function 'com.lightningkite.kiteui.views.expanding' call
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    var this_2 = weight(element_2, 1.0);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_5 = new (Space())(this_2.get_context_h02k06_k$());
    ensureOutermostElement(element_5);
    this_2.willAddChild_hz2iwc_k$(element_5);
    element_5.onStartup_vrxh3i_k$();
    this_2.addChild_2qpft2_k$(element_5);
    // Inline function 'com.lightningkite.kiteui.views.important' call
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    var this_3 = themed(element_2, ImportantSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    var this_4 = themed(this_3, ButtonSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_6 = new (Button())(this_4.get_context_h02k06_k$());
    ensureOutermostElement(element_6);
    this_4.willAddChild_hz2iwc_k$(element_6);
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_7 = new (TextView())(element_6.get_context_h02k06_k$());
    ensureOutermostElement(element_7);
    element_6.willAddChild_hz2iwc_k$(element_7);
    var tmp_5 = KMutableProperty0();
    var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_7);
    var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_7));
    element_7.invoke_bnq13k_k$(tmp_7, addLocationDialog$lambda$lambda_1);
    element_7.onStartup_vrxh3i_k$();
    element_6.addChild_2qpft2_k$(element_7);
    element_6.set_action_2ds022_k$(Action('Add location', VOID, VOID, VOID, VOID, VOID, addLocationDialog$lambda$slambda_0(location, $this$with, element_6, close, clearDraft)));
    element_6.onStartup_vrxh3i_k$();
    this_4.addChild_2qpft2_k$(element_6);
    element_2.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_2);
    element.onStartup_vrxh3i_k$();
    this_0.addChild_2qpft2_k$(element);
    return Unit_instance;
  });
  return Unit_instance;
}
function monthOf(date) {
  var start = LocalDate().new_kotlinx_datetime_LocalDate_rqj1zf_k$(date.year_1, date.get_month_ivc8d3_k$(), 1);
  return new (ClosedLocalDateRange())(start, minus(plus_0(start, DatePeriod().new_kotlinx_datetime_DatePeriod_19p8ip_k$(VOID, 1)), DatePeriod().new_kotlinx_datetime_DatePeriod_19p8ip_k$(VOID, VOID, 1)));
}
function eligibleMonths(now, existingPeriods, signedPlacements) {
  var currentMonth = monthOf(now);
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s = existingPeriods.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    if (!(element.submitted_1 == null)) {
      destination.add_utx5q5_k$(element);
    }
  }
  var tmp$ret$3;
  $l$block: {
    // Inline function 'kotlin.collections.maxOfOrNull' call
    var iterator = destination.iterator_jk1svi_k$();
    if (!iterator.hasNext_bitz1p_k$()) {
      tmp$ret$3 = null;
      break $l$block;
    }
    var maxValue = iterator.next_20eer_k$().period_1.endInclusive_1;
    while (iterator.hasNext_bitz1p_k$()) {
      var v = iterator.next_20eer_k$().period_1.endInclusive_1;
      if (compareTo(maxValue, v) < 0) {
        maxValue = v;
      }
    }
    tmp$ret$3 = maxValue;
  }
  var lastSubmittedEnd = tmp$ret$3;
  var tmp$ret$6;
  $l$block_0: {
    // Inline function 'kotlin.collections.minOfOrNull' call
    var iterator_0 = signedPlacements.iterator_jk1svi_k$();
    if (!iterator_0.hasNext_bitz1p_k$()) {
      tmp$ret$6 = null;
      break $l$block_0;
    }
    var minValue = iterator_0.next_20eer_k$().activeRange_1.start_1;
    while (iterator_0.hasNext_bitz1p_k$()) {
      var v_0 = iterator_0.next_20eer_k$().activeRange_1.start_1;
      if (compareTo(minValue, v_0) > 0) {
        minValue = v_0;
      }
    }
    tmp$ret$6 = minValue;
  }
  var earliestPlacementStart = tmp$ret$6;
  var scanStart = !(lastSubmittedEnd == null) ? monthOf(plus_0(lastSubmittedEnd, DatePeriod().new_kotlinx_datetime_DatePeriod_19p8ip_k$(VOID, VOID, 1))).start_1 : !(earliestPlacementStart == null) ? monthOf(earliestPlacementStart).start_1 : currentMonth.start_1;
  // Inline function 'kotlin.collections.mutableListOf' call
  var candidates = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var monthStart = scanStart;
  while (monthStart.compareTo_e7gwgq_k$(currentMonth.start_1) <= 0) {
    candidates.add_utx5q5_k$(monthOf(monthStart));
    monthStart = plus_0(monthStart, DatePeriod().new_kotlinx_datetime_DatePeriod_19p8ip_k$(VOID, 1));
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s_0 = candidates.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
    var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
    var tmp;
    var tmp$ret$13;
    $l$block_2: {
      // Inline function 'kotlin.collections.any' call
      var tmp_0;
      if (isInterface(signedPlacements, Collection())) {
        tmp_0 = signedPlacements.isEmpty_y1axqb_k$();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$13 = false;
        break $l$block_2;
      }
      var _iterator__ex2g4s_1 = signedPlacements.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
        var element_1 = _iterator__ex2g4s_1.next_20eer_k$();
        if (!(element_1.activeRange_1.overlap_uapg8u_k$(element_0) == null)) {
          tmp$ret$13 = true;
          break $l$block_2;
        }
      }
      tmp$ret$13 = false;
    }
    if (tmp$ret$13) {
      var tmp$ret$15;
      $l$block_4: {
        // Inline function 'kotlin.collections.none' call
        var tmp_1;
        if (isInterface(existingPeriods, Collection())) {
          tmp_1 = existingPeriods.isEmpty_y1axqb_k$();
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$15 = true;
          break $l$block_4;
        }
        var _iterator__ex2g4s_2 = existingPeriods.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
          var element_2 = _iterator__ex2g4s_2.next_20eer_k$();
          if (!((new (LocalDateRange())(element_2.period_1.start_1, element_2.period_1.endInclusive_1)).overlap_uapg8u_k$(element_0) == null)) {
            tmp$ret$15 = false;
            break $l$block_4;
          }
        }
        tmp$ret$15 = true;
      }
      tmp = tmp$ret$15;
    } else {
      tmp = false;
    }
    if (tmp) {
      destination_0.add_utx5q5_k$(element_0);
    }
  }
  return destination_0;
}
function addAttendancePeriodDialog(_this__u8e3s4, location) {
  return dialog(_this__u8e3s4, VOID, ($this$dialog, close) => {
    var elementContext = _this__u8e3s4;
    var selected = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(null);
    var existingPeriods = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
      var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_locationAttendancePeriods_kbvlcb_k$();
      // Inline function 'com.lightningkite.services.database.Query' call
      // Inline function 'kotlin.collections.listOf' call
      var orderBy = emptyList();
      // Inline function 'com.lightningkite.services.database.path' call
      // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
      var tmp_0 = serializerOrContextual(createKType(getKClass(LocationAttendancePeriod()), arrayOf([]), false));
      var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
      new (DataClassPathSelf())(tmp$ret$3);
      // Inline function 'com.lightningkite.services.database.condition' call
      // Inline function 'com.lightningkite.services.database.path' call
      // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
      var tmp_1 = serializerOrContextual(createKType(getKClass(LocationAttendancePeriod()), arrayOf([]), false));
      var tmp$ret$7 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
      // Inline function 'kotlin.let' call
      var it = new (DataClassPathSelf())(tmp$ret$7);
      var tmp$ret$4 = eq(get_location(it), new (ID())(location._id_1));
      var tmp$ret$0 = new (Query())(tmp$ret$4, orderBy, 0, 100);
      return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$0));
    });
    var signedPlacements = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
      var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_childrenPlacement_hazabn_k$();
      // Inline function 'com.lightningkite.services.database.Query' call
      // Inline function 'kotlin.collections.listOf' call
      var orderBy = emptyList();
      // Inline function 'com.lightningkite.services.database.path' call
      // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
      var tmp_0 = serializerOrContextual(createKType(getKClass(ChildPlacement()), arrayOf([]), false));
      var tmp$ret$13 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
      new (DataClassPathSelf())(tmp$ret$13);
      // Inline function 'com.lightningkite.services.database.condition' call
      // Inline function 'com.lightningkite.services.database.path' call
      // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
      var tmp_1 = serializerOrContextual(createKType(getKClass(ChildPlacement()), arrayOf([]), false));
      var tmp$ret$17 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
      // Inline function 'kotlin.let' call
      var it = new (DataClassPathSelf())(tmp$ret$17);
      var tmp$ret$14 = and(eq(get_location_0(it), new (ID())(location._id_1)), neq(get_signedDocument(it), null));
      var tmp$ret$10 = new (Query())(tmp$ret$14, orderBy, 0, 100);
      return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$10));
    });
    var months = remember(VOID, VOID, VOID, VOID, ($this$remember) => eligibleMonths(nowLocal().get_date_wokkxj_k$(), $this$remember.invoke_r7m7el_k$(existingPeriods), $this$remember.invoke_r7m7el_k$(signedPlacements)));
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    var this_0 = get_scrolling(sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, get_standardDialogWidth()));
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
    ensureOutermostElement(element);
    this_0.willAddChild_hz2iwc_k$(element);
    element.set_vertical_nuap32_k$(true);
    // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = new (TextView())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    element.willAddChild_hz2iwc_k$(element_0);
    element_0.set_themeChoice_py59um_k$(element_0.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
    var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
    element_0.invoke_bnq13k_k$(tmp_1, addAttendancePeriodDialog$lambda$lambda);
    element_0.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_0);
    // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_1 = new (TextView())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_1);
    element.willAddChild_hz2iwc_k$(element_1);
    element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
    var tmp_2 = KMutableProperty0();
    var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_1);
    var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_1));
    element_1.invoke_bnq13k_k$(tmp_4, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).locationChooseMonthSubtext_17dav3_k$(location.name_1));
    element_1.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    var this_1 = shownWhen(element, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(months).isEmpty_y1axqb_k$());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_2 = new (TextView())(this_1.get_context_h02k06_k$());
    ensureOutermostElement(element_2);
    this_1.willAddChild_hz2iwc_k$(element_2);
    element_2.set_themeChoice_py59um_k$(element_2.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
    var tmp_5 = KMutableProperty0();
    var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_2);
    var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_2));
    element_2.invoke_bnq13k_k$(tmp_7, addAttendancePeriodDialog$lambda$lambda_0);
    element_2.onStartup_vrxh3i_k$();
    this_1.addChild_2qpft2_k$(element_2);
    colOf(element, months, VOID, VOID, VOID, ($this$colOf, month) => {
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      var this_0 = dynamicThemed($this$colOf, ($this$dynamicThemed) => equals($this$dynamicThemed.invoke_r7m7el_k$(selected), $this$dynamicThemed.invoke_r7m7el_k$(month)) ? SelectedSemantic_getInstance() : None_instance);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element = new (Button())(this_0.get_context_h02k06_k$());
      ensureOutermostElement(element);
      this_0.willAddChild_hz2iwc_k$(element);
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_0 = new (TextView())(element.get_context_h02k06_k$());
      ensureOutermostElement(element_0);
      element.willAddChild_hz2iwc_k$(element_0);
      var tmp = KMutableProperty0();
      var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
      var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
      element_0.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(month).toString());
      element_0.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_0);
      onClick(element, VOID, VOID, VOID, addAttendancePeriodDialog$lambda$lambda$slambda(selected, month));
      element.onStartup_vrxh3i_k$();
      this_0.addChild_2qpft2_k$(element);
      return Unit_instance;
    });
    // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_3 = new (Separator())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_3);
    element.willAddChild_hz2iwc_k$(element_3);
    element_3.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_3);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_4 = new (RowOrCol())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_4);
    element.willAddChild_hz2iwc_k$(element_4);
    element_4.set_vertical_nuap32_k$(false);
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    var this_2 = themed(element_4, ButtonSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_5 = new (Button())(this_2.get_context_h02k06_k$());
    ensureOutermostElement(element_5);
    this_2.willAddChild_hz2iwc_k$(element_5);
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_6 = new (TextView())(element_5.get_context_h02k06_k$());
    ensureOutermostElement(element_6);
    element_5.willAddChild_hz2iwc_k$(element_6);
    var tmp_8 = KMutableProperty0();
    var tmp_9 = TextView$_get_content_$ref_4pzcwl(element_6);
    var tmp_10 = getPropertyCallableRef('content', 0, tmp_8, tmp_9, TextView$_set_content_$ref_pketfb(element_6));
    element_6.invoke_bnq13k_k$(tmp_10, addAttendancePeriodDialog$lambda$lambda_1);
    element_6.onStartup_vrxh3i_k$();
    element_5.addChild_2qpft2_k$(element_6);
    onClick(element_5, VOID, VOID, VOID, addAttendancePeriodDialog$lambda$slambda(close));
    element_5.onStartup_vrxh3i_k$();
    this_2.addChild_2qpft2_k$(element_5);
    // Inline function 'com.lightningkite.kiteui.views.expanding' call
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    var this_3 = weight(element_4, 1.0);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_7 = new (Space())(this_3.get_context_h02k06_k$());
    ensureOutermostElement(element_7);
    this_3.willAddChild_hz2iwc_k$(element_7);
    element_7.onStartup_vrxh3i_k$();
    this_3.addChild_2qpft2_k$(element_7);
    // Inline function 'com.lightningkite.kiteui.views.important' call
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    var this_4 = themed(element_4, ImportantSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    var this_5 = themed(this_4, ButtonSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_8 = new (Button())(this_5.get_context_h02k06_k$());
    ensureOutermostElement(element_8);
    this_5.willAddChild_hz2iwc_k$(element_8);
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_9 = new (TextView())(element_8.get_context_h02k06_k$());
    ensureOutermostElement(element_9);
    element_8.willAddChild_hz2iwc_k$(element_9);
    var tmp_11 = KMutableProperty0();
    var tmp_12 = TextView$_get_content_$ref_4pzcwl(element_9);
    var tmp_13 = getPropertyCallableRef('content', 0, tmp_11, tmp_12, TextView$_set_content_$ref_pketfb(element_9));
    element_9.invoke_bnq13k_k$(tmp_13, addAttendancePeriodDialog$lambda$lambda_2);
    element_9.onStartup_vrxh3i_k$();
    element_8.addChild_2qpft2_k$(element_9);
    var tmp_14 = KMutableProperty0();
    var tmp_15 = Button$_get_enabled_$ref_61t7nx(element_8);
    var tmp_16 = getPropertyCallableRef('enabled', 0, tmp_14, tmp_15, Button$_set_enabled_$ref_o8kynz(element_8));
    element_8.invoke_bnq13k_k$(tmp_16, ($this$invoke) => !($this$invoke.invoke_r7m7el_k$(selected) == null));
    element_8.set_action_2ds022_k$(Action('Add attendance period', VOID, VOID, VOID, VOID, VOID, addAttendancePeriodDialog$lambda$slambda_0(selected, location, close, elementContext)));
    element_8.onStartup_vrxh3i_k$();
    this_5.addChild_2qpft2_k$(element_8);
    element_4.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_4);
    element.onStartup_vrxh3i_k$();
    this_0.addChild_2qpft2_k$(element);
    return Unit_instance;
  });
}
function addClosureDialog(form, _this__u8e3s4, locations) {
  // Inline function 'kotlin.with' call
  var $this$with = form;
  dialog(_this__u8e3s4, VOID, ($this$dialog, close) => {
    var date = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(nowLocal().get_date_wokkxj_k$());
    var reason = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(ClosureReason_Holiday_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    var this_0 = get_scrolling(sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, get_standardDialogWidth()));
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
    ensureOutermostElement(element);
    this_0.willAddChild_hz2iwc_k$(element);
    element.set_vertical_nuap32_k$(true);
    // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = new (TextView())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    element.willAddChild_hz2iwc_k$(element_0);
    element_0.set_themeChoice_py59um_k$(element_0.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
    var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
    element_0.invoke_bnq13k_k$(tmp_1, addClosureDialog$lambda$lambda);
    element_0.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_0);
    // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    var this_1 = shownWhen(element, VOID, VOID, ($this$shownWhen) => locations.get_size_woubt6_k$() === 1);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_1 = new (TextView())(this_1.get_context_h02k06_k$());
    ensureOutermostElement(element_1);
    this_1.willAddChild_hz2iwc_k$(element_1);
    element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
    var tmp_2 = KMutableProperty0();
    var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_1);
    var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_1));
    element_1.invoke_bnq13k_k$(tmp_4, ($this$invoke) => first(locations).name_1);
    element_1.onStartup_vrxh3i_k$();
    this_1.addChild_2qpft2_k$(element_1);
    // Inline function 'org.thecommunitygroupinc.cares.theme.bannerTheme' call
    var this_2 = shownWhen(element, VOID, VOID, ($this$shownWhen) => locations.get_size_woubt6_k$() > 1);
    // Inline function 'com.lightningkite.kiteui.views.important' call
    var this_3 = themed(this_2, BannerSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    var this_4 = themed(this_3, ImportantSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_2 = new (RowOrCol())(this_4.get_context_h02k06_k$());
    ensureOutermostElement(element_2);
    this_4.willAddChild_hz2iwc_k$(element_2);
    element_2.set_vertical_nuap32_k$(true);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    var this_5 = themed(element_2, LabelGapSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_3 = new (RowOrCol())(this_5.get_context_h02k06_k$());
    ensureOutermostElement(element_3);
    this_5.willAddChild_hz2iwc_k$(element_3);
    element_3.set_vertical_nuap32_k$(true);
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    var this_6 = get_bold(element_3);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_4 = new (TextView())(this_6.get_context_h02k06_k$());
    ensureOutermostElement(element_4);
    this_6.willAddChild_hz2iwc_k$(element_4);
    var tmp_5 = KMutableProperty0();
    var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_4);
    var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_4));
    element_4.invoke_bnq13k_k$(tmp_7, addClosureDialog$lambda$lambda_0);
    element_4.onStartup_vrxh3i_k$();
    this_6.addChild_2qpft2_k$(element_4);
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_5 = new (TextView())(element_3.get_context_h02k06_k$());
    ensureOutermostElement(element_5);
    element_3.willAddChild_hz2iwc_k$(element_5);
    var tmp_8 = KMutableProperty0();
    var tmp_9 = TextView$_get_content_$ref_4pzcwl(element_5);
    var tmp_10 = getPropertyCallableRef('content', 0, tmp_8, tmp_9, TextView$_set_content_$ref_pketfb(element_5));
    element_5.invoke_bnq13k_k$(tmp_10, addClosureDialog$lambda$lambda_1);
    element_5.onStartup_vrxh3i_k$();
    element_3.addChild_2qpft2_k$(element_5);
    element_3.onStartup_vrxh3i_k$();
    this_5.addChild_2qpft2_k$(element_3);
    element_2.onStartup_vrxh3i_k$();
    this_4.addChild_2qpft2_k$(element_2);
    var tmp_11 = addClosureDialog$lambda$lambda_2;
    var tmp_12 = addClosureDialog$lambda$lambda_3;
    $this$with.dateField$default_ksnshl_k$(element, tmp_11, assertNotNull(date.lens_drj4fu_k$(tmp_12, addClosureDialog$lambda$lambda_4)), true);
    var tmp_13 = addClosureDialog$lambda$lambda_5;
    var tmp_14 = assertNotNull(reason);
    var tmp_15 = _Constant___init__impl__v45mub(toList(get_entries_0()));
    $this$with.selectField_qav2qe_k$(element, tmp_13, tmp_14, new (Constant())(tmp_15), true, addClosureDialog$lambda$lambda_6);
    // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_6 = new (Separator())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_6);
    element.willAddChild_hz2iwc_k$(element_6);
    element_6.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_6);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_7 = new (RowOrCol())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_7);
    element.willAddChild_hz2iwc_k$(element_7);
    element_7.set_vertical_nuap32_k$(false);
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    var this_7 = themed(element_7, ButtonSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_8 = new (Button())(this_7.get_context_h02k06_k$());
    ensureOutermostElement(element_8);
    this_7.willAddChild_hz2iwc_k$(element_8);
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_9 = new (TextView())(element_8.get_context_h02k06_k$());
    ensureOutermostElement(element_9);
    element_8.willAddChild_hz2iwc_k$(element_9);
    var tmp_16 = KMutableProperty0();
    var tmp_17 = TextView$_get_content_$ref_4pzcwl(element_9);
    var tmp_18 = getPropertyCallableRef('content', 0, tmp_16, tmp_17, TextView$_set_content_$ref_pketfb(element_9));
    element_9.invoke_bnq13k_k$(tmp_18, addClosureDialog$lambda$lambda_7);
    element_9.onStartup_vrxh3i_k$();
    element_8.addChild_2qpft2_k$(element_9);
    onClick(element_8, VOID, VOID, VOID, addClosureDialog$lambda$slambda(close));
    element_8.onStartup_vrxh3i_k$();
    this_7.addChild_2qpft2_k$(element_8);
    // Inline function 'com.lightningkite.kiteui.views.expanding' call
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    var this_8 = weight(element_7, 1.0);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_10 = new (Space())(this_8.get_context_h02k06_k$());
    ensureOutermostElement(element_10);
    this_8.willAddChild_hz2iwc_k$(element_10);
    element_10.onStartup_vrxh3i_k$();
    this_8.addChild_2qpft2_k$(element_10);
    // Inline function 'com.lightningkite.kiteui.views.important' call
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    var this_9 = themed(element_7, ImportantSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    var this_10 = themed(this_9, ButtonSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_11 = new (Button())(this_10.get_context_h02k06_k$());
    ensureOutermostElement(element_11);
    this_10.willAddChild_hz2iwc_k$(element_11);
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_12 = new (TextView())(element_11.get_context_h02k06_k$());
    ensureOutermostElement(element_12);
    element_11.willAddChild_hz2iwc_k$(element_12);
    var tmp_19 = KMutableProperty0();
    var tmp_20 = TextView$_get_content_$ref_4pzcwl(element_12);
    var tmp_21 = getPropertyCallableRef('content', 0, tmp_19, tmp_20, TextView$_set_content_$ref_pketfb(element_12));
    element_12.invoke_bnq13k_k$(tmp_21, ($this$invoke) => locations.get_size_woubt6_k$() > 1 ? $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationAddClosuresButton_8pcv03_k$() : $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationAddClosureButton_djcbau_k$());
    element_12.onStartup_vrxh3i_k$();
    element_11.addChild_2qpft2_k$(element_12);
    element_11.set_action_2ds022_k$(Action('Add closure', VOID, VOID, VOID, VOID, VOID, addClosureDialog$lambda$slambda_0(date, reason, locations, close, element_11)));
    element_11.onStartup_vrxh3i_k$();
    this_10.addChild_2qpft2_k$(element_11);
    element_7.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_7);
    element.onStartup_vrxh3i_k$();
    this_0.addChild_2qpft2_k$(element);
    return Unit_instance;
  });
  return Unit_instance;
}
function editClosureDialog(form, _this__u8e3s4, closure, location) {
  // Inline function 'kotlin.with' call
  var $this$with = form;
  dialog(_this__u8e3s4, VOID, ($this$dialog, close) => {
    var date = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(closure.date_1);
    var reason = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(closure.reason_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    var this_0 = get_scrolling(sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, get_standardDialogWidth()));
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
    ensureOutermostElement(element);
    this_0.willAddChild_hz2iwc_k$(element);
    element.set_vertical_nuap32_k$(true);
    // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = new (TextView())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    element.willAddChild_hz2iwc_k$(element_0);
    element_0.set_themeChoice_py59um_k$(element_0.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
    var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
    element_0.invoke_bnq13k_k$(tmp_1, ($this$invoke) => 'Edit closure for ' + location.name_1);
    element_0.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_0);
    var tmp_2 = editClosureDialog$lambda$lambda;
    var tmp_3 = editClosureDialog$lambda$lambda_0;
    $this$with.dateField$default_ksnshl_k$(element, tmp_2, assertNotNull(date.lens_drj4fu_k$(tmp_3, editClosureDialog$lambda$lambda_1)), true);
    var tmp_4 = editClosureDialog$lambda$lambda_2;
    var tmp_5 = assertNotNull(reason);
    var tmp_6 = _Constant___init__impl__v45mub(toList(get_entries_0()));
    $this$with.selectField_qav2qe_k$(element, tmp_4, tmp_5, new (Constant())(tmp_6), true, editClosureDialog$lambda$lambda_3);
    // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_1 = new (Separator())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_1);
    element.willAddChild_hz2iwc_k$(element_1);
    element_1.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_2 = new (RowOrCol())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_2);
    element.willAddChild_hz2iwc_k$(element_2);
    element_2.set_vertical_nuap32_k$(false);
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    var this_1 = themed(element_2, ButtonSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_3 = new (Button())(this_1.get_context_h02k06_k$());
    ensureOutermostElement(element_3);
    this_1.willAddChild_hz2iwc_k$(element_3);
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_4 = new (TextView())(element_3.get_context_h02k06_k$());
    ensureOutermostElement(element_4);
    element_3.willAddChild_hz2iwc_k$(element_4);
    var tmp_7 = KMutableProperty0();
    var tmp_8 = TextView$_get_content_$ref_4pzcwl(element_4);
    var tmp_9 = getPropertyCallableRef('content', 0, tmp_7, tmp_8, TextView$_set_content_$ref_pketfb(element_4));
    element_4.invoke_bnq13k_k$(tmp_9, editClosureDialog$lambda$lambda_4);
    element_4.onStartup_vrxh3i_k$();
    element_3.addChild_2qpft2_k$(element_4);
    onClick(element_3, VOID, VOID, VOID, editClosureDialog$lambda$slambda(close));
    element_3.onStartup_vrxh3i_k$();
    this_1.addChild_2qpft2_k$(element_3);
    // Inline function 'com.lightningkite.kiteui.views.expanding' call
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    var this_2 = weight(element_2, 1.0);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_5 = new (Space())(this_2.get_context_h02k06_k$());
    ensureOutermostElement(element_5);
    this_2.willAddChild_hz2iwc_k$(element_5);
    element_5.onStartup_vrxh3i_k$();
    this_2.addChild_2qpft2_k$(element_5);
    // Inline function 'com.lightningkite.kiteui.views.danger' call
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    var this_3 = themed(element_2, DangerSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    var this_4 = themed(this_3, ButtonSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_6 = new (Button())(this_4.get_context_h02k06_k$());
    ensureOutermostElement(element_6);
    this_4.willAddChild_hz2iwc_k$(element_6);
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_7 = new (TextView())(element_6.get_context_h02k06_k$());
    ensureOutermostElement(element_7);
    element_6.willAddChild_hz2iwc_k$(element_7);
    var tmp_10 = KMutableProperty0();
    var tmp_11 = TextView$_get_content_$ref_4pzcwl(element_7);
    var tmp_12 = getPropertyCallableRef('content', 0, tmp_10, tmp_11, TextView$_set_content_$ref_pketfb(element_7));
    element_7.invoke_bnq13k_k$(tmp_12, editClosureDialog$lambda$lambda_5);
    element_7.onStartup_vrxh3i_k$();
    element_6.addChild_2qpft2_k$(element_7);
    element_6.set_action_2ds022_k$(Action('Delete closure', VOID, VOID, VOID, VOID, VOID, editClosureDialog$lambda$slambda_0(element_6, closure, close)));
    element_6.onStartup_vrxh3i_k$();
    this_4.addChild_2qpft2_k$(element_6);
    // Inline function 'com.lightningkite.kiteui.views.important' call
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    var this_5 = themed(element_2, ImportantSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    var this_6 = themed(this_5, ButtonSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_8 = new (Button())(this_6.get_context_h02k06_k$());
    ensureOutermostElement(element_8);
    this_6.willAddChild_hz2iwc_k$(element_8);
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_9 = new (TextView())(element_8.get_context_h02k06_k$());
    ensureOutermostElement(element_9);
    element_8.willAddChild_hz2iwc_k$(element_9);
    var tmp_13 = KMutableProperty0();
    var tmp_14 = TextView$_get_content_$ref_4pzcwl(element_9);
    var tmp_15 = getPropertyCallableRef('content', 0, tmp_13, tmp_14, TextView$_set_content_$ref_pketfb(element_9));
    element_9.invoke_bnq13k_k$(tmp_15, editClosureDialog$lambda$lambda_6);
    element_9.onStartup_vrxh3i_k$();
    element_8.addChild_2qpft2_k$(element_9);
    element_8.set_action_2ds022_k$(Action('Save closure', VOID, VOID, VOID, VOID, VOID, editClosureDialog$lambda$slambda_1(date, reason, closure, close, element_8)));
    element_8.onStartup_vrxh3i_k$();
    this_6.addChild_2qpft2_k$(element_8);
    element_2.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_2);
    element.onStartup_vrxh3i_k$();
    this_0.addChild_2qpft2_k$(element);
    return Unit_instance;
  });
  return Unit_instance;
}
function addLocationRateDialog(form, _this__u8e3s4, location) {
  // Inline function 'kotlin.with' call
  var $this$with = form;
  dialog(_this__u8e3s4, VOID, ($this$dialog, close) => {
    var name = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$('');
    var template = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(null);
    var since = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(nowLocal().get_date_wokkxj_k$());
    var templates = remember(VOID, VOID, VOID, VOID, addLocationRateDialog$lambda$lambda);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    var this_0 = get_scrolling(sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, get_standardDialogWidth()));
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
    ensureOutermostElement(element);
    this_0.willAddChild_hz2iwc_k$(element);
    element.set_vertical_nuap32_k$(true);
    // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = new (TextView())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    element.willAddChild_hz2iwc_k$(element_0);
    element_0.set_themeChoice_py59um_k$(element_0.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
    var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
    element_0.invoke_bnq13k_k$(tmp_1, addLocationRateDialog$lambda$lambda_0);
    element_0.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_0);
    subtext(element, location.name_1);
    var tmp_2 = addLocationRateDialog$lambda$lambda_1;
    var tmp_3 = audit(name, addLocationRateDialog$lambda$lambda_2);
    $this$with.stringField_7ac68e_k$(element, tmp_2, tmp_3, false, ($this$stringField) => {
      var tmp = KMutableProperty0();
      var tmp_0 = TextInput$_get_hint_$ref_uvwrja($this$stringField);
      var tmp_1 = getPropertyCallableRef('hint', 0, tmp, tmp_0, TextInput$_set_hint_$ref_i30g2i($this$stringField));
      $this$stringField.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
        var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(template);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.shortName_1;
        return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
      });
      return Unit_instance;
    });
    var tmp_4 = addLocationRateDialog$lambda$lambda_3;
    var tmp_5 = assertNotNull(template);
    var tmp_6 = remember(VOID, VOID, VOID, VOID, ($this$remember) => plus(listOf(null), $this$remember.invoke_r7m7el_k$(templates)));
    $this$with.selectField_qav2qe_k$(element, tmp_4, tmp_5, tmp_6, true, addLocationRateDialog$lambda$lambda_4);
    $this$with.dateField$default_ksnshl_k$(element, addLocationRateDialog$lambda$lambda_5, assertNotNull(since), true);
    // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_1 = new (Separator())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_1);
    element.willAddChild_hz2iwc_k$(element_1);
    element_1.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_2 = new (RowOrCol())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_2);
    element.willAddChild_hz2iwc_k$(element_2);
    element_2.set_vertical_nuap32_k$(false);
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    var this_1 = themed(element_2, ButtonSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_3 = new (Button())(this_1.get_context_h02k06_k$());
    ensureOutermostElement(element_3);
    this_1.willAddChild_hz2iwc_k$(element_3);
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_4 = new (TextView())(element_3.get_context_h02k06_k$());
    ensureOutermostElement(element_4);
    element_3.willAddChild_hz2iwc_k$(element_4);
    var tmp_7 = KMutableProperty0();
    var tmp_8 = TextView$_get_content_$ref_4pzcwl(element_4);
    var tmp_9 = getPropertyCallableRef('content', 0, tmp_7, tmp_8, TextView$_set_content_$ref_pketfb(element_4));
    element_4.invoke_bnq13k_k$(tmp_9, addLocationRateDialog$lambda$lambda_6);
    element_4.onStartup_vrxh3i_k$();
    element_3.addChild_2qpft2_k$(element_4);
    onClick(element_3, VOID, VOID, VOID, addLocationRateDialog$lambda$slambda(close));
    element_3.onStartup_vrxh3i_k$();
    this_1.addChild_2qpft2_k$(element_3);
    // Inline function 'com.lightningkite.kiteui.views.expanding' call
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    var this_2 = weight(element_2, 1.0);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_5 = new (Space())(this_2.get_context_h02k06_k$());
    ensureOutermostElement(element_5);
    this_2.willAddChild_hz2iwc_k$(element_5);
    element_5.onStartup_vrxh3i_k$();
    this_2.addChild_2qpft2_k$(element_5);
    // Inline function 'com.lightningkite.kiteui.views.important' call
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    var this_3 = themed(element_2, ImportantSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    var this_4 = themed(this_3, ButtonSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_6 = new (Button())(this_4.get_context_h02k06_k$());
    ensureOutermostElement(element_6);
    this_4.willAddChild_hz2iwc_k$(element_6);
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_7 = new (TextView())(element_6.get_context_h02k06_k$());
    ensureOutermostElement(element_7);
    element_6.willAddChild_hz2iwc_k$(element_7);
    var tmp_10 = KMutableProperty0();
    var tmp_11 = TextView$_get_content_$ref_4pzcwl(element_7);
    var tmp_12 = getPropertyCallableRef('content', 0, tmp_10, tmp_11, TextView$_set_content_$ref_pketfb(element_7));
    element_7.invoke_bnq13k_k$(tmp_12, addLocationRateDialog$lambda$lambda_7);
    element_7.onStartup_vrxh3i_k$();
    element_6.addChild_2qpft2_k$(element_7);
    var tmp_13 = KMutableProperty0();
    var tmp_14 = Button$_get_enabled_$ref_61t7nx(element_6);
    var tmp_15 = getPropertyCallableRef('enabled', 0, tmp_13, tmp_14, Button$_set_enabled_$ref_o8kynz(element_6));
    element_6.invoke_bnq13k_k$(tmp_15, ($this$invoke) => !($this$invoke.invoke_r7m7el_k$(template) == null) && !($this$invoke.invoke_r7m7el_k$(since) == null));
    element_6.set_action_2ds022_k$(Action('Add rate', VOID, VOID, VOID, VOID, VOID, addLocationRateDialog$lambda$slambda_0(template, since, location, name, close, element_6)));
    element_6.onStartup_vrxh3i_k$();
    this_4.addChild_2qpft2_k$(element_6);
    element_2.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_2);
    element.onStartup_vrxh3i_k$();
    this_0.addChild_2qpft2_k$(element);
    return Unit_instance;
  });
  return Unit_instance;
}
function locationForm$lambda($this$stringField) {
  return $this$stringField.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationNameLabel_iz62q3_k$();
}
function locationForm$lambda_0($this$selectField) {
  return 'Type';
}
function locationForm$lambda_1(it) {
  return it.displayName_1;
}
function locationForm$lambda_2($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationAddressSectionTitle_ooy4vd_k$();
}
function locationForm$lambda_3($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationStreetAddressLabel_1akgf5_k$();
}
function locationForm$lambda_4($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationAptSuiteLabel_qtfjst_k$();
}
function locationForm$lambda_5($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationCityLabel_jq20et_k$();
}
function locationForm$lambda_6($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationStateLabel_vycy69_k$();
}
function locationForm$lambda_7($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationZipcodeLabel_ph92sc_k$();
}
function locationForm$lambda_8($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationContactSectionTitle_jjah7v_k$();
}
function locationForm$lambda_9($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationContactNameLabel_3ysqd5_k$();
}
function locationForm$lambda_10($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationContactEmailLabel_efzqw6_k$();
}
function locationForm$lambda_11($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationContactPhoneLabel_4m2zrc_k$();
}
function addLocationDialog$lambda$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationAddDialogTitle_cinmfn_k$();
}
function addLocationDialog$lambda$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudCancelButton_yk4tir_k$();
}
function addLocationDialog$lambda$slambda($location, $close) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    $location.cancel_2l89ey_k$();
    $close();
    return Unit_instance;
  }), 0);
}
function addLocationDialog$lambda$lambda_1($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationAddButton_95bquj_k$();
}
function addLocationDialog$lambda$slambda_0($location, $$this$with, $$this$button, $close, $clearDraft) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_issues($location);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!(yield* await_0(this_0, $completion)).isEmpty_y1axqb_k$()) {
      yield* $$this$with.get_showValidation_c0zzxd_k$().set_revjhg_k$(true, $completion);
      return Unit_instance;
    }
    var saved = yield* $location.publish_xq9q2e_k$($completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = get_currentSessionNotNull();
    yield* (yield* await_0(this_1, $completion)).get_careLocations_f1rtw_k$().add_co22jy_k$(saved, $completion);
    var tmp_0 = $$this$button.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = get_strings(AppState_getInstance());
    var tmp$ret$3 = yield* await_1(this_2, $completion);
    toast(tmp_0, tmp$ret$3.get_locationAddedToast_8hz6sl_k$());
    $close();
    yield* $($clearDraft($completion), $completion);
    return Unit_instance;
  }), 1);
}
function addAttendancePeriodDialog$lambda$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationAddAttendancePeriodButton_2ztszj_k$();
}
function addAttendancePeriodDialog$lambda$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationNoEligibleMonthsMessage_5awsde_k$();
}
function addAttendancePeriodDialog$lambda$lambda$slambda($selected, $month) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $month;
    var tmp$ret$0 = yield* await_0(this_0, $completion);
    yield* $selected.set_revjhg_k$(tmp$ret$0, $completion);
    return Unit_instance;
  }), 0);
}
function addAttendancePeriodDialog$lambda$lambda_1($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudCancelButton_yk4tir_k$();
}
function addAttendancePeriodDialog$lambda$slambda($close) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    $close();
    return Unit_instance;
  }), 0);
}
function addAttendancePeriodDialog$lambda$lambda_2($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationAddAttendancePeriodButton_2ztszj_k$();
}
function addAttendancePeriodDialog$lambda$slambda_0($selected, $location, $close, $elementContext) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $selected;
    var tmp0_elvis_lhs = yield* await_1(this_0, $completion);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var month = tmp;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = get_currentSessionNotNull();
    var created = yield* (yield* await_0(this_1, $completion)).get_locationAttendancePeriods_kbvlcb_k$().add_co22jy_k$(new (LocationAttendancePeriod())(VOID, $location._id_1, $location.provider_1, month), $completion);
    $close();
    get_pageNavigator($elementContext).navigate_sm5lxf_k$(new (AttendancePeriodDetailPage())(created._id_1));
    return Unit_instance;
  }), 1);
}
function addClosureDialog$lambda$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationAddClosureButton_djcbau_k$();
}
function addClosureDialog$lambda$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationClosureUmbrellaWarning_b148pn_k$();
}
function addClosureDialog$lambda$lambda_1($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationClosureSpecificLocationHint_htzknp_k$();
}
function addClosureDialog$lambda$lambda_2($this$dateField) {
  return $this$dateField.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationClosureDateLabel_yxq7hz_k$();
}
function addClosureDialog$lambda$lambda_3(it) {
  return it;
}
function addClosureDialog$lambda$lambda_4(it) {
  return it == null ? today() : it;
}
function addClosureDialog$lambda$lambda_5($this$selectField) {
  return $this$selectField.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationClosureReasonLabel_jr4c1f_k$();
}
function addClosureDialog$lambda$lambda_6(it) {
  var tmp1_elvis_lhs = it == null ? null : it.displayName_1;
  return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
}
function addClosureDialog$lambda$lambda_7($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudCancelButton_yk4tir_k$();
}
function addClosureDialog$lambda$slambda($close) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    $close();
    return Unit_instance;
  }), 0);
}
function addClosureDialog$lambda$slambda_0($date, $reason, $locations, $close, $$this$button) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $date;
    var tmp0_elvis_lhs = yield* await_1(this_0, $completion);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var chosenDate = tmp;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $reason;
    var tmp1_elvis_lhs = yield* await_1(this_1, $completion);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var chosenReason = tmp_0;
    // Inline function 'kotlin.collections.map' call
    var this_2 = $locations;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_2, 10));
    var _iterator__ex2g4s = this_2.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      var tmp$ret$4 = new (CareLocationClosure())(VOID, item.provider_1, item._id_1, chosenDate, chosenReason);
      destination.add_utx5q5_k$(tmp$ret$4);
    }
    var closures = destination;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = get_currentSessionNotNull();
    yield* (yield* await_0(this_3, $completion)).get_careLocationClosures_im9skn_k$().addAll_zaft0n_k$(closures, $completion);
    $close();
    var tmp_1 = $$this$button.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_4 = get_strings(AppState_getInstance());
    var tmp$ret$6 = yield* await_1(this_4, $completion);
    toast(tmp_1, tmp$ret$6.get_locationClosureAddedToast_kquvus_k$());
    return Unit_instance;
  }), 1);
}
function editClosureDialog$lambda$lambda($this$dateField) {
  return $this$dateField.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationClosureDateLabel_yxq7hz_k$();
}
function editClosureDialog$lambda$lambda_0(it) {
  return it;
}
function editClosureDialog$lambda$lambda_1(it) {
  return it == null ? today() : it;
}
function editClosureDialog$lambda$lambda_2($this$selectField) {
  return $this$selectField.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationClosureReasonLabel_jr4c1f_k$();
}
function editClosureDialog$lambda$lambda_3(it) {
  var tmp1_elvis_lhs = it == null ? null : it.displayName_1;
  return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
}
function editClosureDialog$lambda$lambda_4($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudCancelButton_yk4tir_k$();
}
function editClosureDialog$lambda$slambda($close) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    $close();
    return Unit_instance;
  }), 0);
}
function editClosureDialog$lambda$lambda_5($this$invoke) {
  return 'Delete';
}
function editClosureDialog$lambda$slambda$lambda($this$confirmationDialog) {
  text($this$confirmationDialog, 'Are you sure you want to delete this closure?');
  return Unit_instance;
}
function editClosureDialog$lambda$slambda$slambda($closure, $close) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    yield* (yield* await_0(this_0, $completion)).get_careLocationClosures_im9skn_k$().get_6ueaa7_k$(new (ID_0())($closure._id_1)).delete_4td7nw_k$($completion);
    $close();
    return Unit_instance;
  }), 0);
}
function editClosureDialog$lambda$slambda_0($$this$button, $closure, $close) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp = $$this$button.get_context_h02k06_k$();
    var tmp_0 = editClosureDialog$lambda$slambda$lambda;
    var tmp_1 = DangerSemantic_getInstance();
    confirmationDialog(tmp, 'Delete closure', tmp_0, 'Delete closure', tmp_1, VOID, VOID, editClosureDialog$lambda$slambda$slambda($closure, $close));
    return Unit_instance;
  }), 1);
}
function editClosureDialog$lambda$lambda_6($this$invoke) {
  return 'Save closure';
}
function editClosureDialog$lambda$slambda_1($date, $reason, $closure, $close, $$this$button) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $date;
    var tmp0_elvis_lhs = yield* await_1(this_0, $completion);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var chosenDate = tmp;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $reason;
    var tmp1_elvis_lhs = yield* await_1(this_1, $completion);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var chosenReason = tmp_0;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = get_currentSessionNotNull();
    var tmp_1 = (yield* await_0(this_2, $completion)).get_careLocationClosures_im9skn_k$().get_6ueaa7_k$(new (ID_0())($closure._id_1));
    // Inline function 'com.lightningkite.services.database.modification' call
    // Inline function 'kotlin.apply' call
    var this_3 = new (ModificationBuilder())();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_2 = serializerOrContextual(createKType(getKClass(CareLocationClosure()), arrayOf([]), false));
    var tmp$ret$7 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$7);
    this_3.assign_vtsfu6_k$(get_date(it), chosenDate);
    this_3.assign_vtsfu6_k$(get_reason(it), chosenReason);
    var tmp$ret$3 = this_3.build_1k0s4u_k$();
    yield* tmp_1.modify_ff53f_k$(tmp$ret$3, $completion);
    $close();
    var tmp_3 = $$this$button.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_4 = get_strings(AppState_getInstance());
    var tmp$ret$9 = yield* await_1(this_4, $completion);
    toast(tmp_3, tmp$ret$9.get_locationClosureAddedToast_kquvus_k$());
    return Unit_instance;
  }), 1);
}
function addLocationRateDialog$lambda$lambda($this$remember) {
  return $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careProgramTemplates_ojj53j_k$().query_so6xq1_k$(new (Query())(Always_getInstance(), VOID, VOID, 50)));
}
function addLocationRateDialog$lambda$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationAddRateButton_ve9lbf_k$();
}
function addLocationRateDialog$lambda$lambda_1($this$stringField) {
  return $this$stringField.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationPrototypeNameLabel_o3rt51_k$();
}
function addLocationRateDialog$lambda$lambda_2(it) {
  return null;
}
function addLocationRateDialog$lambda$lambda_3($this$selectField) {
  return $this$selectField.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationPlanLabel_xccdpp_k$();
}
function addLocationRateDialog$lambda$lambda_4(it) {
  var tmp1_elvis_lhs = it == null ? null : it.name_1;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    var tmp2_elvis_lhs = ReactiveState__getOrNull_impl_1asnfp(get_strings(AppState_getInstance()).get_state_wc71uu_k$());
    tmp = (tmp2_elvis_lhs == null ? StringsForLanguage_English_getInstance() : tmp2_elvis_lhs).get_locationSelectPlanPlaceholder_e7rncg_k$();
  } else {
    tmp = tmp1_elvis_lhs;
  }
  return tmp;
}
function addLocationRateDialog$lambda$lambda_5($this$dateField) {
  return $this$dateField.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateOnThisPlanSinceLabel_vdwh5j_k$();
}
function addLocationRateDialog$lambda$lambda_6($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudCancelButton_yk4tir_k$();
}
function addLocationRateDialog$lambda$slambda($close) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    $close();
    return Unit_instance;
  }), 0);
}
function addLocationRateDialog$lambda$lambda_7($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_locationAddRateButton_ve9lbf_k$();
}
function addLocationRateDialog$lambda$slambda_0($template, $since, $location, $name, $close, $$this$button) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $template;
    var tmp0_elvis_lhs = yield* await_1(this_0, $completion);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var chosenTemplate = tmp;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $since;
    var tmp1_elvis_lhs = yield* await_1(this_1, $completion);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var chosenSince = tmp_0;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = get_currentSessionNotNull();
    var tmp_1 = (yield* await_0(this_2, $completion)).get_careLocationPrograms_g0oima_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = $name;
    // Inline function 'kotlin.text.ifBlank' call
    var this_4 = yield* await_1(this_3, $completion);
    var tmp_2;
    if (isBlank(this_4)) {
      tmp_2 = chosenTemplate.shortName_1;
    } else {
      tmp_2 = this_4;
    }
    var tmp$ret$4 = tmp_2;
    yield* tmp_1.add_co22jy_k$(new (CareLocationProgram())(VOID, $location._id_1, $location.provider_1, tmp$ret$4, chosenTemplate._id_1, chosenSince, VOID, chosenTemplate.careTime_1, chosenTemplate.ageStart_1, chosenTemplate.ageEndInclusive_1, chosenTemplate.availableAsIntermittent_1), $completion);
    $close();
    var tmp_3 = $$this$button.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_5 = get_strings(AppState_getInstance());
    var tmp$ret$6 = yield* await_1(this_5, $completion);
    toast(tmp_3, tmp$ret$6.get_locationRateAddedToast_4hcq1n_k$());
    return Unit_instance;
  }), 1);
}
//region block: exports
export {
  addAttendancePeriodDialog as addAttendancePeriodDialogtbnknfp2bbke,
  addClosureDialog as addClosureDialogmoz60sf1yaca,
  addLocationDialog as addLocationDialog2nfoxx4583r7s,
  addLocationRateDialog as addLocationRateDialogykpwmkgv3k40,
  editClosureDialog as editClosureDialog19dt1cpachlxe,
  locationForm as locationFormhh7qfpr9thx,
};
//endregion

//# sourceMappingURL=locationComponents.mjs.map
